// extracted by mini-css-extract-plugin
module.exports = {"column10":"_1c39327f","section":"_06b23d14","container":"_f8775c93","text":"_341b804e","buttons":"_b90a13a1","button":"_3ad67c8b"};